import React from "react";
import InfoPage from ".";

const OurStory = () => {
  const body = [
    `We have always dreamed of owning a second home in the mountains. Our vision included a cozy place where we could take advantage of being outdoors year-around hiking, biking and skiing/snowboarding with friends and family.  In 2017, Jamie was diagnosed with cancer.  Upon hearing that devastating news, we decided life was too short and it was time to make our dream a reality.  We determined the only way we could afford to own a second home was to rent out our property when we weren't using it.  Knowing nothing about the short-term rental business, we took a leap of faith and purchased our first property in beautiful Breckenridge, Colorado.`,

    `Immediately, we knew we needed a fresh approach to marketing to have our property stand out among the thousands of other rentals, so we turned to content creators for help. The positive impact these collaborations had on our business inspired additional partnerships with numerous amazing creators.  Bookings increased steadily, as did our social media account. We quickly discovered, however, that there was no easy way for hosts to find creators or for creators to find hosts without exchanging awkward DMs on Instagram.  Which is why we created Postaway. Our goal at Postaway is to streamline the travel collaboration process and make marketing fun, effective and easy again. And since we were gathering so many talented travel creators and unique stays in one place, we figured why not let travelers in on the fun too!`,

    `Jamie has been cancer free for several years now and we are living out our motto of "Make Every Day Count".  We now own 5 properties in Colorado and in the 30A area of Florida and feel so blessed to have this amazing opportunity.  We hope you will join us on this journey because at Postaway…we're going places.`
  ];

  const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1024;
  const isMobile = windowWidth <= 768;
  const isNarrowMobile = windowWidth >= 350 && windowWidth <= 492;
  
  // Need extra height for narrow mobile viewports (350-492px)
  const getMobileHeight = () => {
    if (isNarrowMobile) return 2100; // Extra height for narrow screens
    if (isMobile) return 1800;
    return undefined;
  };
  
  const signOffWithImage = (
    <div style={{ 
      display: 'inline-flex', 
      alignItems: 'center', 
      gap: isMobile ? '16px' : '20px', 
      marginLeft: isMobile ? '0' : '300px',
      flexDirection: isMobile ? 'column' : 'row',
      textAlign: 'center'
    }}>
      <div style={{ 
        textAlign: 'center', 
        lineHeight: '1.5', 
        whiteSpace: 'nowrap', 
        fontSize: isMobile ? '16px' : '18px' 
      }}>
        <div style={{ marginBottom: '4px' }}>xoxo</div>
        <div style={{ marginBottom: '4px' }}>Jamie & Trevor</div>
        <div>Co-Founders, Postaway</div>
      </div>
      <img
        src="/founders.png"
        alt="Jamie & Trevor - Founders of Postaway"
        style={{
          width: isMobile ? '100px' : '120px',
          height: isMobile ? '100px' : '120px',
          objectFit: 'cover',
          borderRadius: '8px',
          flexShrink: 0
        }}
      />
    </div>
  );

  // Heading is rendered as a subtitle under the image by PostcardHero; avoid duplicating it here
  return <InfoPage 
    title="Our Story" 
    body={body} 
    content={signOffWithImage} 
    tallOverride={false}
    customMinHeight={getMobileHeight()}
  />;
};

export default OurStory;


